import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  width: number
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    cursor: 'pointer',
    flexShrink: 0
  },

  menu: {
    marginTop: '-18px',
    marginLeft: '24px',
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    width: ({ width }) => `${width}px`,
    padding: '24px',
    background: 'white'
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  title: {
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  reset: {
    fontSize: theme.size.sm,
    textAlign: 'right',
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },

  sections: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px'
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',

    '&:last-child': {
      marginBottom: '0'
    }
  },

  sectionTitle: {
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  sectionContent: {
    display: 'flex',
    flexWrap: 'wrap'
  },

  item: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4px',
    marginRight: '4px',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    padding: '6px 10px',
    background: 'white',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    cursor: 'pointer',
    userSelect: 'none',

    '&:last-child': {
      marginRight: '0'
    }
  },

  itemSelected: {
    background: '#F8D8FF',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px'
  },

  button: {
    marginBottom: '8px',
    borderRadius: '8px',
    width: '100%',
    fontSize: theme.size.base,

    '&:last-child': {
      marginBottom: '0'
    }
  },

  buttonInvert: {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    background: 'white',

    '&:hover': {
      background: '#F8D8FF'
    }
  }
}))

export default useStyles
